import type { DirektvermarktungGeneratorShareResponse } from "../Direktvermarktung.types";

export type RedispatchStatus = true | false | "mixed" | undefined;

export function getDVRedispatchStatus(
  generationShares: Array<DirektvermarktungGeneratorShareResponse>
): RedispatchStatus {
  if (generationShares.length === 0) return undefined;

  const redispatchStatuses = generationShares
    .map((gs) => gs.is_redispatch_import_active)
    .filter((status) => status !== undefined && status !== null);

  if (redispatchStatuses.length === 0) return undefined;

  const allTrue = redispatchStatuses.every((status) => status === true);
  const allFalse = redispatchStatuses.every((status) => status === false);

  if (allTrue) return true;
  if (allFalse) return false;
  return "mixed";
}
